/**
 * Derives the display label for a style chiclet.
 *
 * Used by CardSet.js when `chiclets.style` is truthy:
 *   - string values → used directly as the label (named style)
 *   - non-string truthy values (e.g. boolean true) → generic "Style" fallback
 */
export function getStyleChicletLabel(styleValue: unknown): string {
  return typeof styleValue === "string" ? styleValue : "Style";
}
